export function short_address(address: string) {
  return address.substring(0, 5) + "..." + address.substring(61, 66);
}

export function sleep(duration: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, duration);
  });
}

export function short_coin_address(address: string) {
  const address_group = address.split("::");
  const short_contract_address =
    address_group[0].substring(0, 4) + "..." + address.substring(63, 66);

  return `${short_contract_address}::${address_group[1]}::${address_group[2]}`;
}

export const getTokenId = (token_name: string): number => {
  const splits = token_name.split("#");
  return parseInt(splits[1], 10);
};

export const getDateFormat = (date: Date): string => {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
};
export const getDateFormat1 = (date: Date): string => {
  if (isNaN(date.getTime())) return "invalid date";
  const month = date.getMonth() + 1;
  const d = date.getDate();
  return `${date.getFullYear()} / ${month < 10 ? `0${month}` : month} / ${
    d < 10 ? `0${d}` : d
  }`;
};

export const vePowerString = (vePower: number): string => {
  if (vePower < 0) {
    return "0";
  }
  if (vePower < 0.01) {
    return "<0.01";
  }
  return vePower.toFixed(2);
};

export const lockingString = (duration: number): string => {
  if (!duration) {
    return "invalid date";
  }
  const absDuration = Math.abs(duration);
  if (duration < 0) {
    if (absDuration <= 30 * 86400) {
      // in a month
      const days = Math.ceil(absDuration / 86400);
      if (days === 1) {
        return "a day ago";
      }
      return `${days} days ago`;
    } else if (absDuration <= 365 * 86400) {
      const months = Math.floor(absDuration / (30 * 86400));
      if (months === 1) {
        return "a month ago";
      }
      return `${months} months ago`;
    } else {
      const years = Math.floor(absDuration / (365 * 86400));
      if (years === 1) {
        return "a year ago";
      }
      return `${years} years ago`;
    }
  } else {
    if (absDuration <= 25 * 86400) {
      // in a month
      const days = Math.ceil(absDuration / 86400);
      if (days === 1) {
        return "in a day";
      }
      return `in ${days} days`;
    } else if (absDuration <= 10 * 30 * 86400) {
      const months = Math.ceil(absDuration / (30 * 86400));
      if (months === 1) {
        return "in a month";
      }
      return `in ${months} months`;
    } else {
      const years = Math.ceil(absDuration / (365 * 86400));
      if (years === 1) {
        return "in a year";
      }
      return `in ${years} years`;
    }
  }
};
